module.exports = __webpack_public_path__ + "img/processos.3552b9c8.png";